import type { GameProvider, Game } from "@/lib/types";

export const providers: GameProvider[] = [
  {
    id: "prov-netent",
    name: "NetEnt",
    slug: "netent",
    description_sv:
      "NetEnt grundades i Stockholm 1996 och är ett av de svenska speltillverkarna som har format dagens onlinecasino. Studions klassiker — Starburst, Gonzo's Quest, Dead or Alive — finns på i princip alla licensierade casinon i Sverige. Spelen är kända för slipade animationer, balanserad volatilitet och hög RTP. NetEnt ingår sedan 2020 i Evolution-koncernen och fortsätter att utveckla nya titlar varje månad.",
    description_en:
      "NetEnt was founded in Stockholm in 1996 and is one of the Swedish studios that shaped today's online casino. Their classics — Starburst, Gonzo's Quest, Dead or Alive — are available at virtually every Swedish-licensed casino. The games are known for polished animation, balanced volatility and high RTP. NetEnt has been part of the Evolution group since 2020 and continues to release new titles monthly.",
    popular_games: ["starburst", "gonzos-quest", "dead-or-alive-2"],
  },
  {
    id: "prov-playngo",
    name: "Play'n GO",
    slug: "playngo",
    description_sv:
      "Play'n GO grundades i Växjö och har sedan dess vuxit till en av Europas mest produktiva spelstudior. Studion är känd för Book of Dead — fortfarande en av de mest spelade slotsen i Sverige — och Reactoonz med dess kluster-mekanik. Play'n GO släpper nya titlar varje månad och håller en hög nivå på både matematik och visuell design.",
    description_en:
      "Play'n GO was founded in Växjö and has grown into one of Europe's most prolific game studios. The studio is known for Book of Dead — still one of the most played slots in Sweden — and for Reactoonz with its cluster mechanic. Play'n GO ships new titles every month and maintains a high standard in both maths and visual design.",
    popular_games: ["book-of-dead", "reactoonz"],
  },
  {
    id: "prov-pragmatic-play",
    name: "Pragmatic Play",
    slug: "pragmatic-play",
    description_sv:
      "Pragmatic Play är en av de största multi-vertikala studiorna globalt med både slots, livecasino, virtuell sport och bingo. På den svenska marknaden är Sweet Bonanza och Gates of Olympus två av de mest spelade titlarna. Studions livecasino-portfölj inkluderar Mega Wheel, Mega Roulette och flera dedikerade Sverige-bord.",
    description_en:
      "Pragmatic Play is one of the largest multi-vertical studios globally, covering slots, live casino, virtual sports and bingo. On the Swedish market Sweet Bonanza and Gates of Olympus are two of the most played titles. The live casino portfolio includes Mega Wheel, Mega Roulette and several dedicated Sweden-facing tables.",
    popular_games: ["sweet-bonanza", "gates-of-olympus"],
  },
  {
    id: "prov-evolution",
    name: "Evolution",
    slug: "evolution",
    description_sv:
      "Evolution är världens dominerande livecasinoleverantör. Studions bord drivs av riktiga dealers från specialbyggda studior — den största i Riga och flera mindre i bland annat Malta, USA och Kanada. Game shows som Crazy Time, Monopoly Live och Lightning Roulette har förändrat hela livecasino-genren. Evolution är dessutom moderbolag till NetEnt, Red Tiger, Nolimit City och Big Time Gaming.",
    description_en:
      "Evolution is the world's dominant live casino provider. Tables are run by real dealers from purpose-built studios — the largest in Riga and several smaller ones in Malta, the United States and Canada. Game shows like Crazy Time, Monopoly Live and Lightning Roulette have reshaped the live casino genre. Evolution is also the parent of NetEnt, Red Tiger, Nolimit City and Big Time Gaming.",
    popular_games: ["crazy-time", "lightning-roulette"],
  },
  {
    id: "prov-yggdrasil",
    name: "Yggdrasil",
    slug: "yggdrasil",
    description_sv: "Yggdrasil är en svenskgrundad studio med fokus på högkvalitativa slots.",
    description_en: "Yggdrasil is a Swedish-founded studio focused on high-quality slots.",
    popular_games: ["vikings-go-berzerk"],
  },
  {
    id: "prov-red-tiger",
    name: "Red Tiger",
    slug: "red-tiger",
    description_sv: "Red Tiger ingår i Evolution och levererar slots med dagliga jackpottar.",
    description_en: "Red Tiger is part of Evolution and delivers slots with daily jackpots.",
    popular_games: ["pirates-plenty"],
  },
  {
    id: "prov-hacksaw-gaming",
    name: "Hacksaw Gaming",
    slug: "hacksaw-gaming",
    description_sv:
      "Hacksaw Gaming är en svensk studio med högvolatila slots som Wanted Dead or a Wild.",
    description_en:
      "Hacksaw Gaming is a Swedish studio behind high-volatility slots like Wanted Dead or a Wild.",
    popular_games: ["wanted-dead-or-a-wild"],
  },
  {
    id: "prov-microgaming",
    name: "Microgaming",
    slug: "microgaming",
    description_sv: "Microgaming är en av de äldsta studiorna och bakom progressiva jackpotts.",
    description_en: "Microgaming is one of the oldest studios and behind progressive jackpots.",
    popular_games: ["mega-moolah"],
  },
  {
    id: "prov-nolimit-city",
    name: "Nolimit City",
    slug: "nolimit-city",
    description_sv: "Nolimit City är kända för innovativa, högvolatila slots.",
    description_en: "Nolimit City is known for innovative, high-volatility slots.",
    popular_games: ["san-quentin"],
  },
  {
    id: "prov-elk-studios",
    name: "Elk Studios",
    slug: "elk-studios",
    description_sv:
      "Elk Studios — speltillverkare. Läs spelreglerna innan du spelar.",
    description_en:
      "Elk Studios — software provider. Read the game rules before playing.",
    popular_games: [],
  },
  {
    id: "prov-relax-gaming",
    name: "Relax Gaming",
    slug: "relax-gaming",
    description_sv:
      "Relax Gaming — speltillverkare. Läs spelreglerna innan du spelar.",
    description_en:
      "Relax Gaming — software provider. Read the game rules before playing.",
    popular_games: [],
  },
  {
    id: "prov-big-time-gaming",
    name: "Big Time Gaming",
    slug: "big-time-gaming",
    description_sv:
      "Big Time Gaming — speltillverkare. Läs spelreglerna innan du spelar.",
    description_en:
      "Big Time Gaming — software provider. Read the game rules before playing.",
    popular_games: [],
  },
  {
    id: "prov-booming-games",
    name: "Booming Games",
    slug: "booming-games",
    description_sv:
      "Booming Games — speltillverkare. Läs spelreglerna innan du spelar.",
    description_en:
      "Booming Games — software provider. Read the game rules before playing.",
    popular_games: [],
  },
  {
    id: "prov-kalamba-games",
    name: "Kalamba Games",
    slug: "kalamba-games",
    description_sv:
      "Kalamba Games — speltillverkare. Läs spelreglerna innan du spelar.",
    description_en:
      "Kalamba Games — software provider. Read the game rules before playing.",
    popular_games: [],
  },
  {
    id: "prov-playtech",
    name: "Playtech",
    slug: "playtech",
    description_sv:
      "Playtech — speltillverkare. Läs spelreglerna innan du spelar.",
    description_en:
      "Playtech — software provider. Read the game rules before playing.",
    popular_games: [],
  },
  {
    id: "prov-push-gaming",
    name: "Push Gaming",
    slug: "push-gaming",
    description_sv:
      "Push Gaming — speltillverkare. Läs spelreglerna innan du spelar.",
    description_en:
      "Push Gaming — software provider. Read the game rules before playing.",
    popular_games: [],
  },
  {
    id: "prov-quickspin",
    name: "Quickspin",
    slug: "quickspin",
    description_sv:
      "Quickspin — speltillverkare. Läs spelreglerna innan du spelar.",
    description_en:
      "Quickspin — software provider. Read the game rules before playing.",
    popular_games: [],
  },
  {
    id: "prov-thunderkick",
    name: "Thunderkick",
    slug: "thunderkick",
    description_sv:
      "Thunderkick — speltillverkare. Läs spelreglerna innan du spelar.",
    description_en:
      "Thunderkick — software provider. Read the game rules before playing.",
    popular_games: [],
  },
  {
    id: "prov-bgaming",
    name: "Bgaming",
    slug: "bgaming",
    description_sv:
      "Bgaming — speltillverkare. Läs spelreglerna innan du spelar.",
    description_en:
      "Bgaming — software provider. Read the game rules before playing.",
    popular_games: [],
  },
  {
    id: "prov-evolution-gaming",
    name: "Evolution Gaming",
    slug: "evolution-gaming",
    description_sv:
      "Evolution Gaming — speltillverkare. Läs spelreglerna innan du spelar.",
    description_en:
      "Evolution Gaming — software provider. Read the game rules before playing.",
    popular_games: [],
  },
  {
    id: "prov-fantasma-games",
    name: "Fantasma Games",
    slug: "fantasma-games",
    description_sv:
      "Fantasma Games — speltillverkare. Läs spelreglerna innan du spelar.",
    description_en:
      "Fantasma Games — software provider. Read the game rules before playing.",
    popular_games: [],
  },
  {
    id: "prov-foxium",
    name: "Foxium",
    slug: "foxium",
    description_sv:
      "Foxium — speltillverkare. Läs spelreglerna innan du spelar.",
    description_en:
      "Foxium — software provider. Read the game rules before playing.",
    popular_games: [],
  },
  {
    id: "prov-gameart",
    name: "Gameart",
    slug: "gameart",
    description_sv:
      "Gameart — speltillverkare. Läs spelreglerna innan du spelar.",
    description_en:
      "Gameart — software provider. Read the game rules before playing.",
    popular_games: [],
  },
  {
    id: "prov-iron-dog-studio",
    name: "Iron Dog Studio",
    slug: "iron-dog-studio",
    description_sv:
      "Iron Dog Studio — speltillverkare. Läs spelreglerna innan du spelar.",
    description_en:
      "Iron Dog Studio — software provider. Read the game rules before playing.",
    popular_games: [],
  },
  {
    id: "prov-mascot-gaming",
    name: "Mascot Gaming",
    slug: "mascot-gaming",
    description_sv:
      "Mascot Gaming — speltillverkare. Läs spelreglerna innan du spelar.",
    description_en:
      "Mascot Gaming — software provider. Read the game rules before playing.",
    popular_games: [],
  },
  {
    id: "prov-playn-go",
    name: "Playn Go",
    slug: "playn-go",
    description_sv:
      "Playn Go — speltillverkare. Läs spelreglerna innan du spelar.",
    description_en:
      "Playn Go — software provider. Read the game rules before playing.",
    popular_games: [],
  },
  {
    id: "prov-red-tiger-gaming",
    name: "Red Tiger Gaming",
    slug: "red-tiger-gaming",
    description_sv:
      "Red Tiger Gaming — speltillverkare. Läs spelreglerna innan du spelar.",
    description_en:
      "Red Tiger Gaming — software provider. Read the game rules before playing.",
    popular_games: [],
  },
  {
    id: "prov-slotmill",
    name: "Slotmill",
    slug: "slotmill",
    description_sv:
      "Slotmill — speltillverkare. Läs spelreglerna innan du spelar.",
    description_en:
      "Slotmill — software provider. Read the game rules before playing.",
    popular_games: [],
  },
  {
    id: "prov-swintt",
    name: "Swintt",
    slug: "swintt",
    description_sv:
      "Swintt — speltillverkare. Läs spelreglerna innan du spelar.",
    description_en:
      "Swintt — software provider. Read the game rules before playing.",
    popular_games: [],
  },
  {
    id: "prov-stakelogic",
    name: "Stakelogic",
    slug: "stakelogic",
    description_sv:
      "Stakelogic — speltillverkare. Läs spelreglerna innan du spelar.",
    description_en:
      "Stakelogic — software provider. Read the game rules before playing.",
    popular_games: [],
  },
  {
    id: "prov-four-leaf-gaming",
    name: "Four Leaf Gaming",
    slug: "four-leaf-gaming",
    description_sv:
      "Four Leaf Gaming — speltillverkare. Läs spelreglerna innan du spelar.",
    description_en:
      "Four Leaf Gaming — software provider. Read the game rules before playing.",
    popular_games: [],
  },
  {
    id: "prov-yggdrasil-gaming",
    name: "Yggdrasil Gaming",
    slug: "yggdrasil-gaming",
    description_sv:
      "Yggdrasil Gaming — speltillverkare. Läs spelreglerna innan du spelar.",
    description_en:
      "Yggdrasil Gaming — software provider. Read the game rules before playing.",
    popular_games: [],
  },
  {
    id: "prov-playson",
    name: "Playson",
    slug: "playson",
    description_sv:
      "Playson — speltillverkare. Läs spelreglerna innan du spelar.",
    description_en:
      "Playson — software provider. Read the game rules before playing.",
    popular_games: [],
  },
  {
    id: "prov-wazdan",
    name: "Wazdan",
    slug: "wazdan",
    description_sv:
      "Wazdan — speltillverkare. Läs spelreglerna innan du spelar.",
    description_en:
      "Wazdan — software provider. Read the game rules before playing.",
    popular_games: [],
  },
  {
    id: "prov-bf-games",
    name: "Bf Games",
    slug: "bf-games",
    description_sv:
      "Bf Games — speltillverkare. Läs spelreglerna innan du spelar.",
    description_en:
      "Bf Games — software provider. Read the game rules before playing.",
    popular_games: [],
  },
  {
    id: "prov-amusnet",
    name: "Amusnet",
    slug: "amusnet",
    description_sv:
      "Amusnet — speltillverkare. Läs spelreglerna innan du spelar.",
    description_en:
      "Amusnet — software provider. Read the game rules before playing.",
    popular_games: [],
  },
  {
    id: "prov-barcrest",
    name: "Barcrest",
    slug: "barcrest",
    description_sv:
      "Barcrest — speltillverkare. Läs spelreglerna innan du spelar.",
    description_en:
      "Barcrest — software provider. Read the game rules before playing.",
    popular_games: [],
  },
  {
    id: "prov-crazy-tooth-studio",
    name: "Crazy Tooth Studio",
    slug: "crazy-tooth-studio",
    description_sv:
      "Crazy Tooth Studio — speltillverkare. Läs spelreglerna innan du spelar.",
    description_en:
      "Crazy Tooth Studio — software provider. Read the game rules before playing.",
    popular_games: [],
  },
  {
    id: "prov-gamebeat",
    name: "Gamebeat",
    slug: "gamebeat",
    description_sv:
      "Gamebeat — speltillverkare. Läs spelreglerna innan du spelar.",
    description_en:
      "Gamebeat — software provider. Read the game rules before playing.",
    popular_games: [],
  },
];

export function findProvider(slug: string): GameProvider | undefined {
  return providers.find((p) => p.slug === slug);
}

export const games: Game[] = [
  {
    id: "game-starburst",
    name: "Starburst",
    slug: "starburst",
    provider_slug: "netent",
    type: "slot",
    rtp: 96.09,
    volatility: "low",
    description_sv:
      "Starburst är NetEnts ikoniska 5-hjuls slot lanserad 2012. Spelet är extremt minimalistiskt — inga bonusrundor, inga free spins, bara expanderande wilds som låser sig på hjulen och triggar omspinn. Med RTP 96,09 % och låg volatilitet är det en av branschens mest älskade nybörjarslots och fortfarande topp-tre på flera svenska casinon.",
    description_en:
      "Starburst is NetEnt's iconic 5-reel slot launched in 2012. The game is intentionally minimalist — no bonus rounds, no free spins, just expanding wilds that lock to the reels and trigger respins. With 96.09% RTP and low volatility it is one of the industry's most loved beginner slots and still a top-three game at several Swedish casinos.",
  },
  {
    id: "game-book-of-dead",
    name: "Book of Dead",
    slug: "book-of-dead",
    provider_slug: "playngo",
    type: "slot",
    rtp: 96.21,
    volatility: "high",
    description_sv:
      "Book of Dead är Play'n GO:s flaggskepp och fortfarande en av Sveriges mest spelade slots flera år efter lanseringen 2016. Du följer äventyraren Rich Wilde i ett egyptiskt tema. Bonusspelet utlöses av tre symboler av boken och ger 10 free spins med en slumpmässig expanderande symbol — kan ge stora vinster om symbolen är hög-värde och expanderar över hjulen.",
    description_en:
      "Book of Dead is Play'n GO's flagship and still one of Sweden's most played slots years after its 2016 launch. You follow the explorer Rich Wilde in an Egyptian theme. The bonus is triggered by three book symbols and grants 10 free spins with a random expanding symbol — capable of huge wins if a high-value symbol expands across the reels.",
  },
  {
    id: "game-sweet-bonanza",
    name: "Sweet Bonanza",
    slug: "sweet-bonanza",
    provider_slug: "pragmatic-play",
    type: "slot",
    rtp: 96.51,
    volatility: "high",
    description_sv: "Sweet Bonanza är ett cluster-pays slot från Pragmatic Play.",
    description_en: "Sweet Bonanza is a cluster-pays slot from Pragmatic Play.",
  },
  {
    id: "game-crazy-time",
    name: "Crazy Time",
    slug: "crazy-time",
    provider_slug: "evolution",
    type: "live",
    description_sv:
      "Crazy Time är ett populärt liveshow-spel från Evolution med fyra olika bonusrundor.",
    description_en:
      "Crazy Time is a popular live show game from Evolution with four bonus rounds.",
  },
  {
    id: "game-lightning-roulette",
    name: "Lightning Roulette",
    slug: "lightning-roulette",
    provider_slug: "evolution",
    type: "live",
    description_sv:
      "Lightning Roulette kombinerar klassisk roulette med multiplikatorblixtar.",
    description_en: "Lightning Roulette combines classic roulette with lightning multipliers.",
  },
  {
    id: "game-reactoonz",
    name: "Reactoonz",
    slug: "reactoonz",
    provider_slug: "playngo",
    type: "slot",
    rtp: 96.51,
    volatility: "high",
    description_sv: "Reactoonz är en cluster-slot med utomjordingar och multipla funktioner.",
    description_en: "Reactoonz is a cluster slot with aliens and multiple cascading features.",
  },
  {
    id: "game-mega-moolah",
    name: "Mega Moolah",
    slug: "mega-moolah",
    provider_slug: "microgaming",
    type: "jackpot",
    rtp: 88.12,
    volatility: "medium",
    description_sv:
      "Mega Moolah är en progressiv jackpotautomat känd för rekordhöga vinster.",
    description_en: "Mega Moolah is a progressive jackpot slot known for record-breaking wins.",
  },
  {
    id: "game-gonzos-quest",
    name: "Gonzo's Quest",
    slug: "gonzos-quest",
    provider_slug: "netent",
    type: "slot",
    rtp: 95.97,
    volatility: "medium",
    description_sv: "Gonzo's Quest har Avalanche-funktionen där symboler faller ned i hjulen.",
    description_en: "Gonzo's Quest features the Avalanche mechanic where symbols cascade.",
  },
  {
    id: "game-big-bamboo",
    name: "Big Bamboo",
    slug: "big-bamboo",
    provider_slug: "netent",
    type: "slot",
    description_sv:
      "Big Bamboo — spelautomat. Läs spelreglerna och sätt en spelbudget.",
    description_en:
      "Big Bamboo — slot game. Read the game rules and set a gambling budget.",
  },
  {
    id: "game-book-of-the-east",
    name: "Book Of The East",
    slug: "book-of-the-east",
    provider_slug: "netent",
    type: "slot",
    description_sv:
      "Book Of The East — spelautomat. Läs spelreglerna och sätt en spelbudget.",
    description_en:
      "Book Of The East — slot game. Read the game rules and set a gambling budget.",
  },
  {
    id: "game-fat-banker",
    name: "Fat Banker",
    slug: "fat-banker",
    provider_slug: "netent",
    type: "slot",
    description_sv:
      "Fat Banker — spelautomat. Läs spelreglerna och sätt en spelbudget.",
    description_en:
      "Fat Banker — slot game. Read the game rules and set a gambling budget.",
  },
  {
    id: "game-gates-of-olympus",
    name: "Gates Of Olympus",
    slug: "gates-of-olympus",
    provider_slug: "netent",
    type: "slot",
    description_sv:
      "Gates Of Olympus — spelautomat. Läs spelreglerna och sätt en spelbudget.",
    description_en:
      "Gates Of Olympus — slot game. Read the game rules and set a gambling budget.",
  },
  {
    id: "game-geisha-wonders",
    name: "Geisha Wonders",
    slug: "geisha-wonders",
    provider_slug: "netent",
    type: "slot",
    description_sv:
      "Geisha Wonders — spelautomat. Läs spelreglerna och sätt en spelbudget.",
    description_en:
      "Geisha Wonders — slot game. Read the game rules and set a gambling budget.",
  },
  {
    id: "game-gem-rocks",
    name: "Gem Rocks",
    slug: "gem-rocks",
    provider_slug: "netent",
    type: "slot",
    description_sv:
      "Gem Rocks — spelautomat. Läs spelreglerna och sätt en spelbudget.",
    description_en:
      "Gem Rocks — slot game. Read the game rules and set a gambling budget.",
  },
  {
    id: "game-go-bananas",
    name: "Go Bananas",
    slug: "go-bananas",
    provider_slug: "netent",
    type: "slot",
    description_sv:
      "Go Bananas — spelautomat. Läs spelreglerna och sätt en spelbudget.",
    description_en:
      "Go Bananas — slot game. Read the game rules and set a gambling budget.",
  },
  {
    id: "game-jungle-books",
    name: "Jungle Books",
    slug: "jungle-books",
    provider_slug: "netent",
    type: "slot",
    description_sv:
      "Jungle Books — spelautomat. Läs spelreglerna och sätt en spelbudget.",
    description_en:
      "Jungle Books — slot game. Read the game rules and set a gambling budget.",
  },
  {
    id: "game-lucha-maniacs",
    name: "Lucha Maniacs",
    slug: "lucha-maniacs",
    provider_slug: "netent",
    type: "slot",
    description_sv:
      "Lucha Maniacs — spelautomat. Läs spelreglerna och sätt en spelbudget.",
    description_en:
      "Lucha Maniacs — slot game. Read the game rules and set a gambling budget.",
  },
  {
    id: "game-ozwins-jackpots",
    name: "Ozwins Jackpots",
    slug: "ozwins-jackpots",
    provider_slug: "netent",
    type: "slot",
    description_sv:
      "Ozwins Jackpots — spelautomat. Läs spelreglerna och sätt en spelbudget.",
    description_en:
      "Ozwins Jackpots — slot game. Read the game rules and set a gambling budget.",
  },
  {
    id: "game-piggy-riches",
    name: "Piggy Riches",
    slug: "piggy-riches",
    provider_slug: "netent",
    type: "slot",
    description_sv:
      "Piggy Riches — spelautomat. Läs spelreglerna och sätt en spelbudget.",
    description_en:
      "Piggy Riches — slot game. Read the game rules and set a gambling budget.",
  },
  {
    id: "game-sticky-bandits",
    name: "Sticky Bandits",
    slug: "sticky-bandits",
    provider_slug: "netent",
    type: "slot",
    description_sv:
      "Sticky Bandits — spelautomat. Läs spelreglerna och sätt en spelbudget.",
    description_en:
      "Sticky Bandits — slot game. Read the game rules and set a gambling budget.",
  },
  {
    id: "game-the-dog-house",
    name: "The Dog House",
    slug: "the-dog-house",
    provider_slug: "netent",
    type: "slot",
    description_sv:
      "The Dog House — spelautomat. Läs spelreglerna och sätt en spelbudget.",
    description_en:
      "The Dog House — slot game. Read the game rules and set a gambling budget.",
  },
  {
    id: "game-viking-honour-xtrawild",
    name: "Viking Honour Xtrawild",
    slug: "viking-honour-xtrawild",
    provider_slug: "netent",
    type: "slot",
    description_sv:
      "Viking Honour Xtrawild — spelautomat. Läs spelreglerna och sätt en spelbudget.",
    description_en:
      "Viking Honour Xtrawild — slot game. Read the game rules and set a gambling budget.",
  },
  {
    id: "game-viking-runes",
    name: "Viking Runes",
    slug: "viking-runes",
    provider_slug: "netent",
    type: "slot",
    description_sv:
      "Viking Runes — spelautomat. Läs spelreglerna och sätt en spelbudget.",
    description_en:
      "Viking Runes — slot game. Read the game rules and set a gambling budget.",
  },
  {
    id: "game-wild-swarm",
    name: "Wild Swarm",
    slug: "wild-swarm",
    provider_slug: "netent",
    type: "slot",
    description_sv:
      "Wild Swarm — spelautomat. Läs spelreglerna och sätt en spelbudget.",
    description_en:
      "Wild Swarm — slot game. Read the game rules and set a gambling budget.",
  },
  {
    id: "game-big-bad-wolf",
    name: "Big Bad Wolf",
    slug: "big-bad-wolf",
    provider_slug: "netent",
    type: "slot",
    description_sv:
      "Big Bad Wolf — spelautomat. Läs spelreglerna och sätt en spelbudget.",
    description_en:
      "Big Bad Wolf — slot game. Read the game rules and set a gambling budget.",
  },
  {
    id: "game-silver-fang",
    name: "Silver Fang",
    slug: "silver-fang",
    provider_slug: "netent",
    type: "slot",
    description_sv:
      "Silver Fang — spelautomat. Läs spelreglerna och sätt en spelbudget.",
    description_en:
      "Silver Fang — slot game. Read the game rules and set a gambling budget.",
  },
  {
    id: "game-asgardian-stones",
    name: "Asgardian Stones",
    slug: "asgardian-stones",
    provider_slug: "netent",
    type: "slot",
    description_sv:
      "Asgardian Stones — spelautomat. Läs spelreglerna och sätt en spelbudget.",
    description_en:
      "Asgardian Stones — slot game. Read the game rules and set a gambling budget.",
  },
  {
    id: "game-easter-island",
    name: "Easter Island",
    slug: "easter-island",
    provider_slug: "netent",
    type: "slot",
    description_sv:
      "Easter Island — spelautomat. Läs spelreglerna och sätt en spelbudget.",
    description_en:
      "Easter Island — slot game. Read the game rules and set a gambling budget.",
  },
  {
    id: "game-rock-n-ways-xtraways",
    name: "Rock N Ways Xtraways",
    slug: "rock-n-ways-xtraways",
    provider_slug: "netent",
    type: "slot",
    description_sv:
      "Rock N Ways Xtraways — spelautomat. Läs spelreglerna och sätt en spelbudget.",
    description_en:
      "Rock N Ways Xtraways — slot game. Read the game rules and set a gambling budget.",
  },
  {
    id: "game-pimped",
    name: "Pimped",
    slug: "pimped",
    provider_slug: "netent",
    type: "slot",
    description_sv:
      "Pimped — spelautomat. Läs spelreglerna och sätt en spelbudget.",
    description_en:
      "Pimped — slot game. Read the game rules and set a gambling budget.",
  },
  {
    id: "game-aloha-spirit-xtralock",
    name: "Aloha Spirit Xtralock",
    slug: "aloha-spirit-xtralock",
    provider_slug: "netent",
    type: "slot",
    description_sv:
      "Aloha Spirit Xtralock — spelautomat. Läs spelreglerna och sätt en spelbudget.",
    description_en:
      "Aloha Spirit Xtralock — slot game. Read the game rules and set a gambling budget.",
  },
  {
    id: "game-esqueleto-explosivo",
    name: "Esqueleto Explosivo",
    slug: "esqueleto-explosivo",
    provider_slug: "netent",
    type: "slot",
    description_sv:
      "Esqueleto Explosivo — spelautomat. Läs spelreglerna och sätt en spelbudget.",
    description_en:
      "Esqueleto Explosivo — slot game. Read the game rules and set a gambling budget.",
  },
  {
    id: "game-jammin-jars-2",
    name: "Jammin Jars 2",
    slug: "jammin-jars-2",
    provider_slug: "netent",
    type: "slot",
    description_sv:
      "Jammin Jars 2 — spelautomat. Läs spelreglerna och sätt en spelbudget.",
    description_en:
      "Jammin Jars 2 — slot game. Read the game rules and set a gambling budget.",
  },
  {
    id: "game-archangels-salvation",
    name: "Archangels Salvation",
    slug: "archangels-salvation",
    provider_slug: "netent",
    type: "slot",
    description_sv:
      "Archangels Salvation — spelautomat. Läs spelreglerna och sätt en spelbudget.",
    description_en:
      "Archangels Salvation — slot game. Read the game rules and set a gambling budget.",
  },
  {
    id: "game-cosmic-fortune",
    name: "Cosmic Fortune",
    slug: "cosmic-fortune",
    provider_slug: "netent",
    type: "slot",
    description_sv:
      "Cosmic Fortune — spelautomat. Läs spelreglerna och sätt en spelbudget.",
    description_en:
      "Cosmic Fortune — slot game. Read the game rules and set a gambling budget.",
  },
  {
    id: "game-dazzle-me",
    name: "Dazzle Me",
    slug: "dazzle-me",
    provider_slug: "netent",
    type: "slot",
    description_sv:
      "Dazzle Me — spelautomat. Läs spelreglerna och sätt en spelbudget.",
    description_en:
      "Dazzle Me — slot game. Read the game rules and set a gambling budget.",
  },
  {
    id: "game-divine-fortune",
    name: "Divine Fortune",
    slug: "divine-fortune",
    provider_slug: "netent",
    type: "slot",
    description_sv:
      "Divine Fortune — spelautomat. Läs spelreglerna och sätt en spelbudget.",
    description_en:
      "Divine Fortune — slot game. Read the game rules and set a gambling budget.",
  },
  {
    id: "game-dracula",
    name: "Dracula",
    slug: "dracula",
    provider_slug: "netent",
    type: "slot",
    description_sv:
      "Dracula — spelautomat. Läs spelreglerna och sätt en spelbudget.",
    description_en:
      "Dracula — slot game. Read the game rules and set a gambling budget.",
  },
  {
    id: "game-butterfly-staxx",
    name: "Butterfly Staxx",
    slug: "butterfly-staxx",
    provider_slug: "netent",
    type: "slot",
    description_sv:
      "Butterfly Staxx — spelautomat. Läs spelreglerna och sätt en spelbudget.",
    description_en:
      "Butterfly Staxx — slot game. Read the game rules and set a gambling budget.",
  },
  {
    id: "game-drive-multiplier-mayhem",
    name: "Drive Multiplier Mayhem",
    slug: "drive-multiplier-mayhem",
    provider_slug: "netent",
    type: "slot",
    description_sv:
      "Drive Multiplier Mayhem — spelautomat. Läs spelreglerna och sätt en spelbudget.",
    description_en:
      "Drive Multiplier Mayhem — slot game. Read the game rules and set a gambling budget.",
  },
  {
    id: "game-emojiplanet",
    name: "Emojiplanet",
    slug: "emojiplanet",
    provider_slug: "netent",
    type: "slot",
    description_sv:
      "Emojiplanet — spelautomat. Läs spelreglerna och sätt en spelbudget.",
    description_en:
      "Emojiplanet — slot game. Read the game rules and set a gambling budget.",
  },
  {
    id: "game-guns-n-roses",
    name: "Guns N Roses",
    slug: "guns-n-roses",
    provider_slug: "netent",
    type: "slot",
    description_sv:
      "Guns N Roses — spelautomat. Läs spelreglerna och sätt en spelbudget.",
    description_en:
      "Guns N Roses — slot game. Read the game rules and set a gambling budget.",
  },
  {
    id: "game-hooks-heroes",
    name: "Hooks Heroes",
    slug: "hooks-heroes",
    provider_slug: "netent",
    type: "slot",
    description_sv:
      "Hooks Heroes — spelautomat. Läs spelreglerna och sätt en spelbudget.",
    description_en:
      "Hooks Heroes — slot game. Read the game rules and set a gambling budget.",
  },
  {
    id: "game-super-lucky-frog-netent",
    name: "Super Lucky Frog Netent",
    slug: "super-lucky-frog-netent",
    provider_slug: "netent",
    type: "slot",
    description_sv:
      "Super Lucky Frog Netent — spelautomat. Läs spelreglerna och sätt en spelbudget.",
    description_en:
      "Super Lucky Frog Netent — slot game. Read the game rules and set a gambling budget.",
  },
  {
    id: "game-mega-fortune-dreams",
    name: "Mega Fortune Dreams",
    slug: "mega-fortune-dreams",
    provider_slug: "netent",
    type: "slot",
    description_sv:
      "Mega Fortune Dreams — spelautomat. Läs spelreglerna och sätt en spelbudget.",
    description_en:
      "Mega Fortune Dreams — slot game. Read the game rules and set a gambling budget.",
  },
  {
    id: "game-hall-of-gods",
    name: "Hall Of Gods",
    slug: "hall-of-gods",
    provider_slug: "netent",
    type: "slot",
    description_sv:
      "Hall Of Gods — spelautomat. Läs spelreglerna och sätt en spelbudget.",
    description_en:
      "Hall Of Gods — slot game. Read the game rules and set a gambling budget.",
  },
  {
    id: "game-jack-and-the-beanstalk",
    name: "Jack And The Beanstalk",
    slug: "jack-and-the-beanstalk",
    provider_slug: "netent",
    type: "slot",
    description_sv:
      "Jack And The Beanstalk — spelautomat. Läs spelreglerna och sätt en spelbudget.",
    description_en:
      "Jack And The Beanstalk — slot game. Read the game rules and set a gambling budget.",
  },
  {
    id: "game-jimi-hendrix",
    name: "Jimi Hendrix",
    slug: "jimi-hendrix",
    provider_slug: "netent",
    type: "slot",
    description_sv:
      "Jimi Hendrix — spelautomat. Läs spelreglerna och sätt en spelbudget.",
    description_en:
      "Jimi Hendrix — slot game. Read the game rules and set a gambling budget.",
  },
  {
    id: "game-arabian-nights",
    name: "Arabian Nights",
    slug: "arabian-nights",
    provider_slug: "netent",
    type: "slot",
    description_sv:
      "Arabian Nights — spelautomat. Läs spelreglerna och sätt en spelbudget.",
    description_en:
      "Arabian Nights — slot game. Read the game rules and set a gambling budget.",
  },
  {
    id: "game-warlords-crystals-of-power",
    name: "Warlords Crystals Of Power",
    slug: "warlords-crystals-of-power",
    provider_slug: "netent",
    type: "slot",
    description_sv:
      "Warlords Crystals Of Power — spelautomat. Läs spelreglerna och sätt en spelbudget.",
    description_en:
      "Warlords Crystals Of Power — slot game. Read the game rules and set a gambling budget.",
  },
  {
    id: "game-jungle-spirit-call-of-the-wild",
    name: "Jungle Spirit Call Of The Wild",
    slug: "jungle-spirit-call-of-the-wild",
    provider_slug: "netent",
    type: "slot",
    description_sv:
      "Jungle Spirit Call Of The Wild — spelautomat. Läs spelreglerna och sätt en spelbudget.",
    description_en:
      "Jungle Spirit Call Of The Wild — slot game. Read the game rules and set a gambling budget.",
  },
  {
    id: "game-koi-princess",
    name: "Koi Princess",
    slug: "koi-princess",
    provider_slug: "netent",
    type: "slot",
    description_sv:
      "Koi Princess — spelautomat. Läs spelreglerna och sätt en spelbudget.",
    description_en:
      "Koi Princess — slot game. Read the game rules and set a gambling budget.",
  },
  {
    id: "game-tornado-farm-escape",
    name: "Tornado Farm Escape",
    slug: "tornado-farm-escape",
    provider_slug: "netent",
    type: "slot",
    description_sv:
      "Tornado Farm Escape — spelautomat. Läs spelreglerna och sätt en spelbudget.",
    description_en:
      "Tornado Farm Escape — slot game. Read the game rules and set a gambling budget.",
  },
  {
    id: "game-theme-park-tickets-of-fortune",
    name: "Theme Park Tickets Of Fortune",
    slug: "theme-park-tickets-of-fortune",
    provider_slug: "netent",
    type: "slot",
    description_sv:
      "Theme Park Tickets Of Fortune — spelautomat. Läs spelreglerna och sätt en spelbudget.",
    description_en:
      "Theme Park Tickets Of Fortune — slot game. Read the game rules and set a gambling budget.",
  },
  {
    id: "game-monster-wheels-microgaming",
    name: "Monster Wheels Microgaming",
    slug: "monster-wheels-microgaming",
    provider_slug: "netent",
    type: "slot",
    description_sv:
      "Monster Wheels Microgaming — spelautomat. Läs spelreglerna och sätt en spelbudget.",
    description_en:
      "Monster Wheels Microgaming — slot game. Read the game rules and set a gambling budget.",
  },
  {
    id: "game-the-legend-of-shangri-la-cluster-pays",
    name: "The Legend Of Shangri La Cluster Pays",
    slug: "the-legend-of-shangri-la-cluster-pays",
    provider_slug: "netent",
    type: "slot",
    description_sv:
      "The Legend Of Shangri La Cluster Pays — spelautomat. Läs spelreglerna och sätt en spelbudget.",
    description_en:
      "The Legend Of Shangri La Cluster Pays — slot game. Read the game rules and set a gambling budget.",
  },
  {
    id: "game-stickers",
    name: "Stickers",
    slug: "stickers",
    provider_slug: "netent",
    type: "slot",
    description_sv:
      "Stickers — spelautomat. Läs spelreglerna och sätt en spelbudget.",
    description_en:
      "Stickers — slot game. Read the game rules and set a gambling budget.",
  },
  {
    id: "game-steam-tower",
    name: "Steam Tower",
    slug: "steam-tower",
    provider_slug: "netent",
    type: "slot",
    description_sv:
      "Steam Tower — spelautomat. Läs spelreglerna och sätt en spelbudget.",
    description_en:
      "Steam Tower — slot game. Read the game rules and set a gambling budget.",
  },
  {
    id: "game-planet-of-the-apes",
    name: "Planet Of The Apes",
    slug: "planet-of-the-apes",
    provider_slug: "netent",
    type: "slot",
    description_sv:
      "Planet Of The Apes — spelautomat. Läs spelreglerna och sätt en spelbudget.",
    description_en:
      "Planet Of The Apes — slot game. Read the game rules and set a gambling budget.",
  },
  {
    id: "game-pyramid-quest-for-immortality",
    name: "Pyramid Quest For Immortality",
    slug: "pyramid-quest-for-immortality",
    provider_slug: "netent",
    type: "slot",
    description_sv:
      "Pyramid Quest For Immortality — spelautomat. Läs spelreglerna och sätt en spelbudget.",
    description_en:
      "Pyramid Quest For Immortality — slot game. Read the game rules and set a gambling budget.",
  },
  {
    id: "game-spinata-grande",
    name: "Spinata Grande",
    slug: "spinata-grande",
    provider_slug: "netent",
    type: "slot",
    description_sv:
      "Spinata Grande — spelautomat. Läs spelreglerna och sätt en spelbudget.",
    description_en:
      "Spinata Grande — slot game. Read the game rules and set a gambling budget.",
  },
  {
    id: "game-sparks",
    name: "Sparks",
    slug: "sparks",
    provider_slug: "netent",
    type: "slot",
    description_sv:
      "Sparks — spelautomat. Läs spelreglerna och sätt en spelbudget.",
    description_en:
      "Sparks — slot game. Read the game rules and set a gambling budget.",
  },
  {
    id: "game-the-invisible-man",
    name: "The Invisible Man",
    slug: "the-invisible-man",
    provider_slug: "netent",
    type: "slot",
    description_sv:
      "The Invisible Man — spelautomat. Läs spelreglerna och sätt en spelbudget.",
    description_en:
      "The Invisible Man — slot game. Read the game rules and set a gambling budget.",
  },
  {
    id: "game-ariana",
    name: "Ariana",
    slug: "ariana",
    provider_slug: "netent",
    type: "slot",
    description_sv:
      "Ariana — spelautomat. Läs spelreglerna och sätt en spelbudget.",
    description_en:
      "Ariana — slot game. Read the game rules and set a gambling budget.",
  },
  {
    id: "game-black-lagoon",
    name: "Black Lagoon",
    slug: "black-lagoon",
    provider_slug: "netent",
    type: "slot",
    description_sv:
      "Black Lagoon — spelautomat. Läs spelreglerna och sätt en spelbudget.",
    description_en:
      "Black Lagoon — slot game. Read the game rules and set a gambling budget.",
  },
  {
    id: "game-money-train-3",
    name: "Money Train 3",
    slug: "money-train-3",
    provider_slug: "netent",
    type: "slot",
    description_sv:
      "Money Train 3 — spelautomat. Läs spelreglerna och sätt en spelbudget.",
    description_en:
      "Money Train 3 — slot game. Read the game rules and set a gambling budget.",
  },
  {
    id: "game-absolootly-mad-mega-moolah",
    name: "Absolootly Mad Mega Moolah",
    slug: "absolootly-mad-mega-moolah",
    provider_slug: "netent",
    type: "slot",
    description_sv:
      "Absolootly Mad Mega Moolah — spelautomat. Läs spelreglerna och sätt en spelbudget.",
    description_en:
      "Absolootly Mad Mega Moolah — slot game. Read the game rules and set a gambling budget.",
  },
  {
    id: "game-all-star-fruits",
    name: "All Star Fruits",
    slug: "all-star-fruits",
    provider_slug: "netent",
    type: "slot",
    description_sv:
      "All Star Fruits — spelautomat. Läs spelreglerna och sätt en spelbudget.",
    description_en:
      "All Star Fruits — slot game. Read the game rules and set a gambling budget.",
  },
  {
    id: "game-alice-wonderluck",
    name: "Alice Wonderluck",
    slug: "alice-wonderluck",
    provider_slug: "netent",
    type: "slot",
    description_sv:
      "Alice Wonderluck — spelautomat. Läs spelreglerna och sätt en spelbudget.",
    description_en:
      "Alice Wonderluck — slot game. Read the game rules and set a gambling budget.",
  },
  {
    id: "game-bakers-treat",
    name: "Bakers Treat",
    slug: "bakers-treat",
    provider_slug: "netent",
    type: "slot",
    description_sv:
      "Bakers Treat — spelautomat. Läs spelreglerna och sätt en spelbudget.",
    description_en:
      "Bakers Treat — slot game. Read the game rules and set a gambling budget.",
  },
  {
    id: "game-banana-town",
    name: "Banana Town",
    slug: "banana-town",
    provider_slug: "netent",
    type: "slot",
    description_sv:
      "Banana Town — spelautomat. Läs spelreglerna och sätt en spelbudget.",
    description_en:
      "Banana Town — slot game. Read the game rules and set a gambling budget.",
  },
  {
    id: "game-beast-below",
    name: "Beast Below",
    slug: "beast-below",
    provider_slug: "netent",
    type: "slot",
    description_sv:
      "Beast Below — spelautomat. Läs spelreglerna och sätt en spelbudget.",
    description_en:
      "Beast Below — slot game. Read the game rules and set a gambling budget.",
  },
  {
    id: "game-bomber-squad",
    name: "Bomber Squad",
    slug: "bomber-squad",
    provider_slug: "netent",
    type: "slot",
    description_sv:
      "Bomber Squad — spelautomat. Läs spelreglerna och sätt en spelbudget.",
    description_en:
      "Bomber Squad — slot game. Read the game rules and set a gambling budget.",
  },
  {
    id: "game-book-of-books",
    name: "Book Of Books",
    slug: "book-of-books",
    provider_slug: "netent",
    type: "slot",
    description_sv:
      "Book Of Books — spelautomat. Läs spelreglerna och sätt en spelbudget.",
    description_en:
      "Book Of Books — slot game. Read the game rules and set a gambling budget.",
  },
  {
    id: "game-book-of-power",
    name: "Book Of Power",
    slug: "book-of-power",
    provider_slug: "netent",
    type: "slot",
    description_sv:
      "Book Of Power — spelautomat. Läs spelreglerna och sätt en spelbudget.",
    description_en:
      "Book Of Power — slot game. Read the game rules and set a gambling budget.",
  },
  {
    id: "game-buffalo-hunter",
    name: "Buffalo Hunter",
    slug: "buffalo-hunter",
    provider_slug: "netent",
    type: "slot",
    description_sv:
      "Buffalo Hunter — spelautomat. Läs spelreglerna och sätt en spelbudget.",
    description_en:
      "Buffalo Hunter — slot game. Read the game rules and set a gambling budget.",
  },
  {
    id: "game-bull-in-a-china-shop",
    name: "Bull In A China Shop",
    slug: "bull-in-a-china-shop",
    provider_slug: "netent",
    type: "slot",
    description_sv:
      "Bull In A China Shop — spelautomat. Läs spelreglerna och sätt en spelbudget.",
    description_en:
      "Bull In A China Shop — slot game. Read the game rules and set a gambling budget.",
  },
  {
    id: "game-castle-builder-2",
    name: "Castle Builder 2",
    slug: "castle-builder-2",
    provider_slug: "netent",
    type: "slot",
    description_sv:
      "Castle Builder 2 — spelautomat. Läs spelreglerna och sätt en spelbudget.",
    description_en:
      "Castle Builder 2 — slot game. Read the game rules and set a gambling budget.",
  },
  {
    id: "game-candy-witch",
    name: "Candy Witch",
    slug: "candy-witch",
    provider_slug: "netent",
    type: "slot",
    description_sv:
      "Candy Witch — spelautomat. Läs spelreglerna och sätt en spelbudget.",
    description_en:
      "Candy Witch — slot game. Read the game rules and set a gambling budget.",
  },
  {
    id: "game-christmas-bonanza",
    name: "Christmas Bonanza",
    slug: "christmas-bonanza",
    provider_slug: "netent",
    type: "slot",
    description_sv:
      "Christmas Bonanza — spelautomat. Läs spelreglerna och sätt en spelbudget.",
    description_en:
      "Christmas Bonanza — slot game. Read the game rules and set a gambling budget.",
  },
  {
    id: "game-crazy-cows",
    name: "Crazy Cows",
    slug: "crazy-cows",
    provider_slug: "netent",
    type: "slot",
    description_sv:
      "Crazy Cows — spelautomat. Läs spelreglerna och sätt en spelbudget.",
    description_en:
      "Crazy Cows — slot game. Read the game rules and set a gambling budget.",
  },
  {
    id: "game-dead-canary",
    name: "Dead Canary",
    slug: "dead-canary",
    provider_slug: "netent",
    type: "slot",
    description_sv:
      "Dead Canary — spelautomat. Läs spelreglerna och sätt en spelbudget.",
    description_en:
      "Dead Canary — slot game. Read the game rules and set a gambling budget.",
  },
  {
    id: "game-dead-mans-gold",
    name: "Dead Mans Gold",
    slug: "dead-mans-gold",
    provider_slug: "netent",
    type: "slot",
    description_sv:
      "Dead Mans Gold — spelautomat. Läs spelreglerna och sätt en spelbudget.",
    description_en:
      "Dead Mans Gold — slot game. Read the game rules and set a gambling budget.",
  },
  {
    id: "game-deadly-5",
    name: "Deadly 5",
    slug: "deadly-5",
    provider_slug: "netent",
    type: "slot",
    description_sv:
      "Deadly 5 — spelautomat. Läs spelreglerna och sätt en spelbudget.",
    description_en:
      "Deadly 5 — slot game. Read the game rules and set a gambling budget.",
  },
  {
    id: "game-disco-dawgs",
    name: "Disco Dawgs",
    slug: "disco-dawgs",
    provider_slug: "netent",
    type: "slot",
    description_sv:
      "Disco Dawgs — spelautomat. Läs spelreglerna och sätt en spelbudget.",
    description_en:
      "Disco Dawgs — slot game. Read the game rules and set a gambling budget.",
  },
  {
    id: "game-doggy-riches-megaways",
    name: "Doggy Riches Megaways",
    slug: "doggy-riches-megaways",
    provider_slug: "netent",
    type: "slot",
    description_sv:
      "Doggy Riches Megaways — spelautomat. Läs spelreglerna och sätt en spelbudget.",
    description_en:
      "Doggy Riches Megaways — slot game. Read the game rules and set a gambling budget.",
  },
  {
    id: "game-dragon-blox-gigablox",
    name: "Dragon Blox Gigablox",
    slug: "dragon-blox-gigablox",
    provider_slug: "netent",
    type: "slot",
    description_sv:
      "Dragon Blox Gigablox — spelautomat. Läs spelreglerna och sätt en spelbudget.",
    description_en:
      "Dragon Blox Gigablox — slot game. Read the game rules and set a gambling budget.",
  },
  {
    id: "game-dragon-wins",
    name: "Dragon Wins",
    slug: "dragon-wins",
    provider_slug: "netent",
    type: "slot",
    description_sv:
      "Dragon Wins — spelautomat. Läs spelreglerna och sätt en spelbudget.",
    description_en:
      "Dragon Wins — slot game. Read the game rules and set a gambling budget.",
  },
];

export function findGame(slug: string): Game | undefined {
  return games.find((g) => g.slug === slug);
}
